import { keyBy, mapValues } from "lodash";
import * as ACTIONS from "../actionTypes";
import {
  applyPlanningAccessReadonlyFlags,
  isPlanningAccessReadonly,
} from "src/allocation/util/planningAccess";

import {
  activeAllocationProject,
  allocationProjectLookup,
  groupLookup,
} from "./mainQueryConversions";

const withPlanningAccessReadonly = (
  state,
  projects,
  activeProject,
  { group, userRole }
) => {
  if (
    !isPlanningAccessReadonly({
      allocationConfig: state,
      group,
      userRole,
    })
  ) {
    return { projects, activeProject };
  }

  return {
    projects: mapValues(projects, applyPlanningAccessReadonlyFlags),
    activeProject: activeProject
      ? applyPlanningAccessReadonlyFlags(activeProject)
      : activeProject,
  };
};

export default (state, action) => {
  switch (action.type) {
    case ACTIONS.MAIN_QUERY_COMPLETE: {
      const { data, userRole } = action;
      const { projects, activeProject } = withPlanningAccessReadonly(
        state,
        allocationProjectLookup(data),
        activeAllocationProject(data),
        { group: data.rootGroup, userRole }
      );
      return {
        ...state,
        groupLookup: groupLookup(state, data),
        activeAllocationProject: activeProject,
        allocationProjectLookup: projects,
        historicAllocationProjectsLookup: keyBy(data.allocationProjects, "id"),
      };
    }
    case ACTIONS.DEMAND_REQUESTS_QUERY_COMPLETE: {
      const { projects, activeProject } = withPlanningAccessReadonly(
        state,
        allocationProjectLookup(action),
        activeAllocationProject(action),
        { group: action.data?.rootGroup, userRole: action.userRole }
      );
      return {
        ...state,
        activeAllocationProject: activeProject,
        allocationProjectLookup: projects,
      };
    }
    case ACTIONS.USER_ADD_ROLE: {
      const { role, supplyRoot } = action;
      const supplyRootGroup = supplyRoot
        ? { [supplyRoot.id]: { ...supplyRoot, isSource: true } }
        : {};

      return {
        ...state,
        groupLookup: {
          ...state.groupLookup,
          [role.id]: { ...role, isSource: true },
          ...supplyRootGroup,
        },
      };
    }
    case ACTIONS.USER_ADD_NEW_TEAM: {
      const { team } = action;
      return {
        ...state,
        groupLookup: {
          ...state.groupLookup,
          [team.id]: { ...team, isSource: false },
        },
      };
    }
    case ACTIONS.TEAM_RENAMED: {
      const { groupId, name } = action;
      return {
        ...state,
        groupLookup: {
          ...state.groupLookup,
          [groupId]: { ...state.groupLookup[groupId], name },
        },
      };
    }
    case ACTIONS.UPDATE_GROUPS_LOOKUP: {
      const { groups } = action;
      return {
        ...state,
        groupLookup: {
          ...state.groupLookup,
          ...groups,
        },
      };
    }
    default:
      return state;
  }
};
